import { gql } from "@apollo/client";

export const GET_CONTROL_RI_APROBADO_BY_EVALUACION = gql`
query GetControlRIAprobadoByEvaluacion ($idEvaluacion: Int!) {
    controlRIAprobado (idEvaluacion: $idEvaluacion)
}`;